import React from 'react';
import { formatCurrency } from '../../utils/currency';

interface OrderTotalsWooCommerceProps {
  order: any;
}

export const OrderTotalsWooCommerce: React.FC<OrderTotalsWooCommerceProps> = ({ order }) => {
  // Calcular subtotal e IVA dos produtos
  const { subtotal, productTax } = order.sourceData?.line_items?.reduce((acc: any, item: any) => {
    return {
      subtotal: acc.subtotal + (parseFloat(item.subtotal) || 0),
      productTax: acc.productTax + (parseFloat(item.total_tax) || 0)
    };
  }, { subtotal: 0, productTax: 0 }) || { subtotal: 0, productTax: 0 };

  // Obter valores dos portes
  const shippingTotal = parseFloat(order.sourceData?.shipping_total || '0');
  const shippingTax = parseFloat(order.sourceData?.shipping_tax || '0');
  
  // Obter total final
  const total = parseFloat(order.sourceData?.total || '0');

  return (
    <div className="mt-4">
      <table className="min-w-full divide-y divide-gray-200">
        <tbody className="bg-white divide-y divide-gray-200">
          <tr>
            <td className="px-6 py-4 text-right" colSpan={4}>
              <span className="text-sm text-gray-900">Subtotal</span>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {formatCurrency(subtotal)}
            </td>
          </tr>

          <tr>
            <td className="px-6 py-4 text-right" colSpan={4}>
              <span className="text-sm text-gray-900">IVA dos Produtos</span>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {formatCurrency(productTax)}
            </td>
          </tr>
          
          {(shippingTotal > 0 || shippingTax > 0) && (
            <tr>
              <td className="px-6 py-4 text-right" colSpan={4}>
                <span className="text-sm text-gray-900">Portes de Envio (+ IVA)</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div>{formatCurrency(shippingTotal)} + {formatCurrency(shippingTax)}</div>
                <div className="text-xs text-gray-500">Total: {formatCurrency(shippingTotal + shippingTax)}</div>
              </td>
            </tr>
          )}

          <tr className="bg-gray-50">
            <td className="px-6 py-4 text-right font-medium" colSpan={4}>
              <span className="text-sm text-gray-900">Total</span>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-bold">
              {formatCurrency(total)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
